export const visit = (vm, at) => {
at({ "en": { "shepherd-react": { "next": "Next", "back": "Back", "finish": "Finish", "cancel": "Cancel", "start": "Start", "stepProgress": "{{ currentStep }} of {{ totalSteps }}" } } });
};